import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { provide, reactive, watch, watchEffect } from 'vue';
import type { StyleValue, CSSProperties } from 'vue';
export type MenuStore = {
  prefixCls?: string;
  selectedKey?: string;
  mode?: 'vertical' | 'horizontal';
  width?: number;
};
export type MenuProps = {
  prefixCls?: string;
  selectedKey?: string;
  mode?: 'vertical' | 'horizontal';
  width?: number;
  style?: StyleValue;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    prefixCls: {},
    selectedKey: {},
    mode: { default: 'vertical' },
    width: {},
    style: { type: [Boolean, null, String, Object, Array], default: {} as any }
  },
  emits: ["update:selectedKey", "click"],
  setup(__props: any, { emit: __emit }) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/18 18:00:08
 * @description: 菜单组件
 */
const props = __props;
const menuStore = reactive<MenuStore>({ selectedKey: '', prefixCls: '', mode: props.mode });

const emit = __emit;
provide<MenuStore>('menuStore', menuStore);

watchEffect(() => Object.assign(menuStore, props));
watch(
  () => menuStore.selectedKey,
  (selectedKey = '') => {
    emit('update:selectedKey', selectedKey);
    emit('click', selectedKey);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass([
      `${menuStore.prefixCls ? menuStore.prefixCls + '-' : ''}menu`,
      `${menuStore.prefixCls ? menuStore.prefixCls + '-' : ''}menu-model--${props.mode}`,
    ]),
    style: _normalizeStyle((Object.assign(__props.style as StyleValue, __props.width && { width: `${__props.width}px` }) as CSSProperties))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})